<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <!-- <img style="display: none;" id='reportLogo' src='@/assets/report_logo.png' alt='Report Logo'> -->
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Brand">
                                        <a-select showSearch v-model="inputBrands" mode="multiple" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="All Brand" allowClear @select="getSubBrandData" @change="clearSubBrand">
                                            <a-select-option v-for="brandOption in brandOptions" :key="brandOption.id" :value="brandOption.id">{{brandOption.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="From"><br>
                                        <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM-DD-YYYY hh:mm A" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                                    </base-input>
                                </div>
                            </div>
        
                            <!-- <div class="row" v-if="site_type == 'ho'">
                                <div class="col-md-7">
                                    <base-input label="Location">
                                        <a-cascader v-model="inputLocation" :options="locationOptions" @change="onLocationChange" placeholder="All Locations" style="width: 100%" />
                                    </base-input>
                                </div>
                            </div> -->
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
                          
                            <div v-if="subBrandOptions.length > 0" class="row">
                                <div class="col-md-7">
                                    <base-input label="Sub Brand">
                                        <a-select v-model="inputSubBrands" placeholder="Select Sub Brand" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" mode="multiple" showSearch >
                                            <a-select-option
                                            v-for="sub_brand_option in subBrandOptions"
                                            :key="sub_brand_option.id"
                                            :value="sub_brand_option.id"
                                            >{{ sub_brand_option.name }}
                                            </a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Product Grade">
                                        <a-select mode="multiple" v-model="inputProductGrade" showSearch placeholder="All Product Group" optionFilterProp="children" style="width: 100%" :filterOption="filterOption"  allowClear >
                                            <a-select-option v-for="productGradeOption in productGradeOptions" :key="productGradeOption.key" :value="productGradeOption.key">{{productGradeOption.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Division">
                                        <a-select mode="multiple" v-model="inputDivision" showSearch placeholder="All Division" optionFilterProp="children" style="width: 100%" :filterOption="filterOption"  allowClear >
                                            <a-select-option v-for="divisionOption in divisionOptions" :key="divisionOption.id" :value="divisionOption.id">{{divisionOption.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;

                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <button v-if="JsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%%;" @click.prevent="generateExcel"> Download excel </button> &nbsp; &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import * as ExcelJS from "exceljs";
    import { saveAs } from "file-saver";

    import {
        mapState,
        mapActions
    } from 'vuex'
    import { getReportDescription } from '../../utilities';

    var component_x;

    export default {
        components: {
            VueJsonToCsv
        },
        data() {
            return {
                spinning: false,
                accessCostPriceRights: [],
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                inputLocation: [],
                locationOptions: [],
                headerExcelInfo: "",
                currDate: moment().format("L_LT").split(":").join(";"),
                isSeparateSite: false,
                isShowDetail: true,
                inputFrom: moment().startOf('month'),
                inputTo: moment().endOf('month'),
                monthFormat: 'MM/YYYY',
                salesInvoiceReports: [],
                params: {},
                advancedFilterVisible: true,

                showSortInfo: 'asc',
                inputShowTop: 0,
                JsonData: [],
                brandOptions: [],
                subBrandOptions: [],
                inputSubBrands: [],
                inputProductGroup: [],
                productGroupOptions: [],
                inputBrands: [],
                inputDivision: [],
                divisionOptions: [],
                inputProductGrade: [],
                productGradeOptions: [
                    {key: 'regular', name: 'Regular'},
                    {key: 'promo', name: 'Promo'},
                    {key: 'sale', name: 'Sale'},
                ],
                reportDescription: ''
            }
        },
        mounted: async function () {
            component_x = this;

            var userId = secureStorage.getItem("userId")

            // Load Access Cost/Price rights (system_module_id 123): 'Z' = cost, 'Y' = price.
            var accessCostPriceRightsRequest = await HTTPRequest.getRequest(component_x.endPoint + 'users/' + userId + "/access_rights?system_module_id=123", null)
            if (accessCostPriceRightsRequest && accessCostPriceRightsRequest.access_rights && accessCostPriceRightsRequest.access_rights[123]) {
                component_x.accessCostPriceRights = accessCostPriceRightsRequest.access_rights[123]
            } else {
                component_x.accessCostPriceRights = []
            }

            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            if(component_x.categoriesOptions.length == 0){
                var options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
                component_x.updateCategoriesOptions(options)
            }

            this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]
            

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
            this.reportDescription = await getReportDescription(this.currentProfile)
            await component_x.getBrandOptions();
            await component_x.getProductGroupOptions();
            await component_x.getDivisionOptions();
        },
        watch: {
 
        },
        computed: {
            ...mapState(['currentProfile', 'endPoint', 'categoriesOptions']),
        },
        methods: {
            ...mapActions(['updateCategoriesOptions']),
            moment,
            async onLocationChange(){
                // alert(this.inputLocation);
                this.siteOptions = await HTTPRequest.getRequest(component_x.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
                this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
                this.inputSite = this.siteOptions.map( s => s.id);
            },
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            autoChange(e){
                if(e.target.value == ''){
                    this.isShowDetail = true
                }
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            addMaskValidation(value, rights){
                if((!this.accessCostPriceRights.includes('Z') && rights == 'Z') || (!this.accessCostPriceRights.includes('Y') && rights == 'Y')){
                    return '***';
                }else{
                    return value
                }
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            changeParams(params){
                this.params = params
            },
            async findName(inputArray, optionsArray){
                let data = []
                inputArray.forEach((el) =>{
                    data.push(optionsArray.find(x => x.id === el).name)
                })
                return data
            },
            generateReport: async function () {
                this.spinning = true;
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let filter_header = '' 
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": from_date,
                    "date_to": to_date,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "product_grade_name": this.inputProductGrade.toString(),
                    "brand_id": this.inputBrands.toString(),
                    "sub_brand_id": this.inputSubBrands.toString(),
                    "division_id": this.inputDivision.toString()    
                }

                let site_filter,brand_filter,date_filter,product_grade_filter,division_filter,sub_brand_filter
                // brand,sub_brand,product_grade,division,date,site
                date_filter = `For the Period of ${from_date} to ${to_date}`

                if(this.inputSite != undefined && this.inputSite.length > 0 && this.inputSite != [] && this.inputSite.length != this.siteOptions.length){
                    let sites = this.siteOptions.filter(x => this.inputSite.includes(x.id)).map(x => x.name)
                    site_filter = "Sites: " + sites 
                }else{
                    site_filter = "Sites: All Sites"
                }

                if(this.inputBrands != undefined && this.inputBrands.length > 0 && this.inputBrands != []){
                    let brands = this.brandOptions.filter(x => this.inputBrands.includes(x.id)).map(x => x.name)
                    brand_filter = "Brands: " + brands 
                }else{
                    brand_filter = "Brands: All Brands"
                }

                if(this.inputSubBrands != undefined && this.inputSubBrands.length > 0 && this.inputSubBrands != []){
                    let sub_brands = this.subBrandOptions.filter(x => this.inputSubBrands.includes(x.id)).map(x => x.name)
                    sub_brand_filter = "Sub Brands: " + sub_brands + " and Null"
                }else{
                    sub_brand_filter = "Sub Brands: All Sub Brands"
                }

                if(this.inputProductGrade != undefined && this.inputProductGrade.length > 0 && this.inputProductGrade != [] && this.inputProductGrade.length != this.productGradeOptions.length){
                    let product_grade = this.productGradeOptions.filter(x => this.inputProductGrade.includes(x.key)).map(x => x.name)
                    product_grade_filter = "Product Grades: " + product_grade + " on user defined fields"
                }else{
                    product_grade_filter = "Product Grades: All Product Grades on user defined fields"
                }

                if(this.inputDivision != undefined && this.inputDivision.length > 0 && this.inputDivision != []){
                    let division = this.divisionOptions.filter(x => this.inputDivision.includes(x.id)).map(x => x.name)
                    division_filter = "Divisions: " + division
                }else{
                    division_filter = "Divisions: All Divisions"
                }
 
                var get_request = await HTTPRequest.getRequest(this.endPoint + 'sales_report_with_invoice_margin?', parameters);
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                    return
                }

                var siteSpecific = get_request;
                
                let design_x = 0
                let design_y = 0

                if(siteSpecific.length > 0){
                    var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    let headers = [];
                    headers = [
                        [
                            {content: 'Month', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Day', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Year', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'QTY', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Sales', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Landed Cost', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Unit Cost', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            // {content: 'Cost of Goods Sold', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Sales Margin', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Sales Margin Value', styles: {width: 'auto',halign: 'center', valign: 'auto'}}
                        ]
                    ]

                    for(let x=0; x < siteSpecific.length; x++){
                        this.negativeMarginItems = siteSpecific[x].report_details

                        if(x > 0 && this.negativeMarginItems.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];

                        if(this.negativeMarginItems.length > 0){

                            for(let i=0; i < this.negativeMarginItems.length; i++){
                                let reportLine = this.negativeMarginItems[i]
                                let detail = []
                                detail = [
                                        reportLine.MONTH,
                                        reportLine.DAY,
                                        reportLine.YEAR,
                                        reportLine.QTY,
                                        this.convertToCurrency(Number(reportLine.SALES_VALUE)),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.LANDED_COST)), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.UNIT_COST)), 'Z'),
                                        // this.convertToCurrency(Number(reportLine.COST_OF_GOODS_SOLD)),
                                        reportLine.SALES_MARGIN,
                                        this.convertToCurrency(Number(reportLine.SALES_MARGIN_VALUE))
                                ]
                            
                                reportData.push(Object.assign({}, detail))

                            }
                        }


                        design_x = 330
                        design_y = 200
                        
                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"Daily Sales Report With Margin")
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        // doc.text(15,25,"For the Period of " + from_header + " to " + to_header)
                        doc.text(15,30,date_filter);
                        doc.text(15,34,site_filter);
                        doc.text(15,38,brand_filter);
                        doc.text(15,42,sub_brand_filter);
                        doc.text(15,46,division_filter);
                        doc.text(15,50,product_grade_filter);

                        let colStyles = {}

                        colStyles = {
                            0: {cellWidth: 'auto',halign: 'left'},
                            1: {cellWidth: 'auto',halign: 'center'},
                            2: {cellWidth: 'auto',halign: 'left'},
                            3: {cellWidth: 'auto',halign: 'right'},
                            4: {cellWidth: 'auto',halign: 'right'},
                            5: {cellWidth: 'auto',halign: 'right'},
                            6: {cellWidth: 'auto',halign: 'right'},
                            7: {cellWidth: 'auto',halign: 'right'},
                            8: {cellWidth: 'auto',halign: 'right'},
                            9: {cellWidth: 'auto',halign: 'right'},
                            10: {cellWidth: 'auto',halign: 'right'},
                            11: {cellWidth: 'auto',halign: 'right'},
                            12: {cellWidth: 'auto',halign: 'right'},
                        }


                        doc.autoTable({
                            startY: 60,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'auto',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            margin: { bottom: 30 },
                            styles: {
                                cellPadding: 1.3, fontSize: 10,
                            },
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0, 0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && (data.row.raw[2] == 'Grand Total' || data.row.raw[3] == 'Grand Total')){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });
                    }
                    // end loop

                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }

                    let pageCount = doc.internal.getNumberOfPages();
                    
                    for(let i = 1; i <= pageCount; i++) {
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, "DailySalesReportMargin", design_x , design_y + 130, i, pageCount)
                    }
                    // await window.open(URL.createObjectURL(doc.output("blob")))
                    doc.save(`DailySalesReportMargin${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    reportUtils.openNotificationWithIcon(component_x,'warning', 'Try increasing the scope by adjusting the filters.');
                }

                this.spinning = false;
            },
            getBase64Image(url) {
                const img = new Image();
                img.setAttribute('crossOrigin', 'anonymous');
                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);
                    const dataURL = canvas.toDataURL("image/png");
                    console.log(dataURL)
                }
                return img.src = url
            },
            async generateExcel(){
                this.spinning = true;
                const workbook = new ExcelJS.Workbook();
                workbook.created = new Date();
                workbook.modified = new Date();
                const sheet = workbook.addWorksheet("Sales Invoice Report by " + this.inputGroupBy, {
                    pageSetup:{paperSize: 9}
                });

                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let site_filter,brand_filter,date_filter,product_grade_filter,division_filter,sub_brand_filter,order_filter,department_filter
                const data_starts_at_row = 13

                // let reportLogo = document.getElementById('reportLogo');
            
                // const base64Image = reportUtils.csvxlsxTools.getBase64Image(reportLogo)

                // const imageId2 = workbook.addImage({
                //     base64: base64Image,
                //     extension: 'png',
                // });

                // sheet.addImage(imageId2, {
                //     tl: { col: 0, row: 0 },
                //     ext: { width: 100, height: 90 }
                // });

                date_filter = `For the Period of ${from_date} to ${to_date}`

                if(this.inputSite != undefined && this.inputSite.length > 0 && this.inputSite != [] && this.inputSite.length != this.siteOptions.length){
                    let sites = this.siteOptions.filter(x => this.inputSite.includes(x.id)).map(x => x.name)
                    site_filter = "Sites: " + sites 
                }else{
                    site_filter = "Sites: All Sites"
                }

                if(this.inputBrands != undefined && this.inputBrands.length > 0 && this.inputBrands != []){
                    let brands = this.brandOptions.filter(x => this.inputBrands.includes(x.id)).map(x => x.name)
                    brand_filter = "Brands: " + brands 
                }else{
                    brand_filter = "Brands: All Brands"
                }

                if(this.inputSubBrands != undefined && this.inputSubBrands.length > 0 && this.inputSubBrands != []){
                    let sub_brands = this.subBrandOptions.filter(x => this.inputSubBrands.includes(x.id)).map(x => x.name)
                    sub_brand_filter = "Sub Brands: " + sub_brands + " and Null"
                }else{
                    sub_brand_filter = "Sub Brands: All Sub Brands"
                }

                if(this.inputProductGrade != undefined && this.inputProductGrade.length > 0 && this.inputProductGrade != [] && this.inputProductGrade.length != this.productGradeOptions.length){
                    let product_grade = this.productGradeOptions.filter(x => this.inputProductGrade.includes(x.key)).map(x => x.name)
                    product_grade_filter = "Product Grades: " + product_grade + " on user defined fields"
                }else{
                    product_grade_filter = "Product Grades: All Product Grades on user defined fields"
                }

                if(this.inputDivision != undefined && this.inputDivision.length > 0 && this.inputDivision != []){
                    let division = this.divisionOptions.filter(x => this.inputDivision.includes(x.id)).map(x => x.name)
                    division_filter = "Divisions: " + division
                }else{
                    division_filter = "Divisions: All Divisions"
                }

                let printed_by = secureStorage.getItem("email")
                if(printed_by == null){
                    printed_by = ''
                }
                let dateNow = moment().format('LL');
 
                sheet.getRow(2).values = ["Sales Invoice Report with Margin"]
                sheet.getRow(4).values = [`${date_filter}`]
                sheet.getRow(5).values = [`${site_filter}`]
                sheet.getRow(6).values = [`${brand_filter}`]
                sheet.getRow(7).values = [`${sub_brand_filter}`]
                sheet.getRow(8).values = [`${division_filter}`]
                sheet.getRow(9).values = [`${product_grade_filter}`]
                sheet.getRow(10).values =[`Printed By ${printed_by}`]
                sheet.getRow(11).values =[`Run Date ${dateNow}`]

                //custom header
                sheet.getRow(data_starts_at_row).values = ["Month", "Day", "Year","QTY","Sales Value","Landed Cost", "Unit Cost","Sales Margin","Sales Margin Value"];
                // sheet.getRow(data_starts_at_row).values = ["Month", "Day", "Year","QTY","Sales Value","Cost of Goods Sold","Sales Margin","Sales Margin Value"];

                // width auto notworking
                sheet.columns = [
                    { key: "month", width: 15 },
                    { key: "day", width: 10 },
                    { key: "year", width: 10 },
                    { key: "qty", width: 20 },
                    { key: "sales_value", width: 15  },
                    { key: "landed_cost", width: 15  },
                    { key: "unit_cost", width: 15  },
                    // { key: "cost_goods_sold", width: 15 },
                    { key: "sales_margin", width: 15 },
                    { key: "sales_margin_value", width: 15 },
                ];

                var sales_report = this.JsonData
                // var sales_report = get_request[0].sales_report
                // console.log("details", sales_report)

                var rowDatas = []
                var horizontal_range = 0
                for(let i = 0; i < sales_report.length; i++){
                    const report_detail = sales_report[i]
                        if(report_detail){
                            const rowData = { 
                                month: report_detail["Month"], day: report_detail["Day"], 
                                year: report_detail["Year"], qty: report_detail["QTY"],
                                sales_value: report_detail["Sales Value"], 
                                // cost_goods_sold: report_detail["Cost of Goods Sold"] ,
                                landed_cost: report_detail["Landed Cost"] ,
                                unit_cost: report_detail["Unit Cost"] ,
                                // "Landed Cost", "Unit Cost"
                                sales_margin: report_detail["Sales Margin"],
                                sales_margin_value: report_detail["Sales Margin Value"]
                            }
                            rowDatas.push(rowData)
                        }
                    }

                sheet.addRows(rowDatas);

                //styles
                sheet.getRow(2).font = { bold: true, size: 16 };
                sheet.getRow(2).height = 20;
                sheet.getRow(13).font = { bold: true };

                // sheet.getRow(data_starts_at_row).eachCell({ includeEmpty: true }, function(cell) {
                //     sheet.getCell(cell.address).fill = { type: 'pattern', pattern: 'darkVertical', fgColor: { argb: '89CFF0'}}
                // })

                sheet.eachRow(function (Row, rowNum) {
                    if(rowNum >= data_starts_at_row){
                        Row.eachCell(function (Cell, cellNum) {
                            if (rowNum == data_starts_at_row) {
                                Cell.alignment = {
                                    horizontal: 'center'
                                }
                            }
                            else{
                                Cell.alignment = {
                                    vertical: 'middle',
                                    horizontal: 'left'
                                }
                            }
                        })
                    }
                })
                
                workbook.xlsx.writeBuffer().then(function(buffer) {
                    const blob = new Blob([buffer], { type: "applicationi/xlsx" });
                    saveAs(blob, `DailySalesReportMargin${moment().format('YYYYMMDDHHmmss')}.xlsx`);
                });
                this.JsonData = []
                this.spinning =false
            },
            generateFile: async function() {
                this.spinning = true;
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": from_date,
                    "date_to": to_date,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "product_grade_name": this.inputProductGrade.toString(),
                    "brand_id": this.inputBrands.toString(),
                    "sub_brand_id": this.inputSubBrands.toString(),
                    "division_id": this.inputDivision.toString()    
                }

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'sales_report_with_invoice_margin?', parameters);
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                    return
                }

                if(get_request.length > 0){
                    let siteSpecific = get_request;

                    let headers = ["Month", "Day", "Year", "QTY", 
                    "Sales Value", "Landed Cost", "Unit Cost", "Sales Margin", "Sales Margin Value"
                    ];

                    let site_specific = [];
    
                    for(let x=0; x < siteSpecific.length; x++){
                        this.dailySalesReportMargin = siteSpecific[x].report_details

                        let reportData = [];
                        if(x > 0){
                            // Add second set of headers
                            reportData.push(headers)
                        }
                        if(this.dailySalesReportMargin.length > 0){
                            console.log(this.dailySalesReportMargin.length)
                            let grouper = 'start'
                            for(let i=0; i < this.dailySalesReportMargin.length; i++){
                                let reportLine =this.dailySalesReportMargin[i]
                                let detail = []
                                detail = [
                                    reportLine.MONTH,
                                    reportLine.DAY,
                                    reportLine.YEAR,
                                    reportLine.QTY,
                                    this.convertToCurrency(Number(reportLine.SALES_VALUE)),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.UNIT_COST)), 'Z'),
                                    // this.convertToCurrency(Number(reportLine.COST_OF_GOODS_SOLD)),
                                    reportLine.SALES_MARGIN,
                                    this.convertToCurrency(Number(reportLine.SALES_MARGIN_VALUE))
                                ]
                                reportData.push(Object.assign({}, detail))
                            }
                        }

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        // reportData.push(["Margin Sales Report" + "Generated By: " + printed_by,"For the Period of " + from_header + " to " + to_header])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                            var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                [val]: values[i][index]
                                }
                            )
                            )
                        );
                        newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                        for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                            obj[i] = '';
                            }
                        }
                        });
                        site_specific.push(newJsonData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'No Data.');
                }
                this.spinning = false;
            },
            clearJsonData(){
             this.JsonData = [];
            },
            async getBrandOptions() {
                var brands = await HTTPRequest.getRequest(
                    this.endPoint + "/brands/get_valid_brands?mode=all",
                    null,
                    null
                );
                // brands.unshift({code: null, id: null, name: '' })
                this.brandOptions = brands;
                
            },

            async getProductGroupOptions() {
                var product_groups = await HTTPRequest.getRequest(
                    this.endPoint + "/product_groups/get_valid_product_groups",
                    null,
                    null
                );
                // brands.unshift({code: null, id: null, name: '' })
                this.productGroupOptions = product_groups;  
            },
            async getDivisionOptions() {
                var divisions = await HTTPRequest.getRequest(
                    this.endPoint + "/categories/get_valid_categories?level=1",
                    null,
                    null
                );
                // brands.unshift({code: null, id: null, name: '' })
                this.divisionOptions = divisions;  
            },


            async getSubBrandData() {
                if (this.inputBrands != null) {
                    var subbrand_data = await HTTPRequest.getRequest(
                    this.endPoint +
                        "sub_brands/get_valid_sub_brands?brand_ids=" +
                        this.inputBrands,
                    null
                    );
                    // console.log("sub_brand[index]:",subbrand_data);
                    this.subBrandOptions = subbrand_data;
                    // console.log(this.inputSubBrands)
                }
            },

            async clearSubBrand() {
                this.inputSubBrands = [];
            },
        }
    };
</script>

<style></style>
